import { render, staticRenderFns } from "./CompanyFormStatus.vue?vue&type=template&id=68a178fc"
import script from "./CompanyFormStatus.vue?vue&type=script&lang=js"
export * from "./CompanyFormStatus.vue?vue&type=script&lang=js"
import style0 from "./CompanyFormStatus.vue?vue&type=style&index=0&id=68a178fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports